/* eslint-disable no-promise-executor-return */
/**
 * Waiter based on given interval time
 * @param timer 
 * @returns 
 */
const proceedWait = (timer) => new Promise((resolve) => setTimeout(resolve, timer));

export default proceedWait;